/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scale_WithInputs */

const en_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scale with`)
};

const es_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escala con`)
};

const fr_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évoluez avec`)
};

const de_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skaliere mit`)
};

const ja_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一緒にスケール`)
};

const zh_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无阻碍扩展`)
};

const ar_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توسع مع`)
};

const id_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skala dengan`)
};

const it_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scala con`)
};

const ru_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Масштабируйтесь с`)
};

const pt_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escale com`)
};

const ko_scale_with = /** @type {(inputs: Scale_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원활한 확장`)
};

/**
* | output |
* | --- |
* | "Scale with" |
*
* @param {Scale_WithInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const scale_with = /** @type {((inputs?: Scale_WithInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scale_WithInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scale_with(inputs)
	if (locale === "es") return es_scale_with(inputs)
	if (locale === "fr") return fr_scale_with(inputs)
	if (locale === "de") return de_scale_with(inputs)
	if (locale === "ja") return ja_scale_with(inputs)
	if (locale === "zh") return zh_scale_with(inputs)
	if (locale === "ar") return ar_scale_with(inputs)
	if (locale === "id") return id_scale_with(inputs)
	if (locale === "it") return it_scale_with(inputs)
	if (locale === "ru") return ru_scale_with(inputs)
	if (locale === "pt") return pt_scale_with(inputs)
	return ko_scale_with(inputs)
});